import script from "./ClientsIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsIndex.vue?vue&type=script&setup=true&lang=js"

import "./ClientsIndex.vue?vue&type=style&index=0&id=bc75a27c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc75a27c"]])

export default __exports__